import { computed, ref } from "vue";
const DEFAULT_PAGE_SIZE = 12;
export function usePagination(opts) {
  const currentPage = ref(opts?.currentPage || 1);
  const pageSize = ref(opts?.pageSize || DEFAULT_PAGE_SIZE);
  const totalPages = ref(opts?.totalPages || 1);
  const hasNextPage = computed(() => {
    return currentPage.value < totalPages.value;
  });
  const hasPrevPage = computed(() => {
    return currentPage.value > 1;
  });
  function nextPage() {
    if (!hasNextPage.value) {
      return;
    }
    currentPage.value++;
  }
  function prevPage() {
    if (!hasPrevPage.value) {
      return;
    }
    currentPage.value--;
  }
  function goToPage(p) {
    currentPage.value = p;
  }
  function updatePageInfo(pageInfo) {
    currentPage.value = pageInfo?.current_page || currentPage.value;
    pageSize.value = pageInfo?.page_size || pageSize.value;
    totalPages.value = pageInfo?.total_pages || totalPages.value;
  }
  return {
    currentPage,
    totalPages,
    pageSize,
    nextPage,
    prevPage,
    goToPage,
    updatePageInfo,
    hasNextPage,
    hasPrevPage
  };
}
